module.exports = __webpack_public_path__ + "img/slide08.db8fce4a.jpg";